import { PayloadAction, SliceCaseReducers, ValidateSliceCaseReducers } from '@reduxjs/toolkit';

import { SeamHealth } from 'app/model';
import { Mcc } from 'app/model/cris/mcc';
import { HealthData } from 'app/model/tools/health-data';

import { SliceState } from './slice-state';

export const reducers: ValidateSliceCaseReducers<SliceState, SliceCaseReducers<SliceState>> = {
    setHealthData: (state, action: PayloadAction<HealthData[]>) => {
        state.healthData = action.payload;
    },

    setSeamHealth: (state, action: PayloadAction<SeamHealth[]>) => {
        state.seamHealth = action.payload;
    },

    setMccLookupVisible: (state, action: PayloadAction<boolean>) => {
        state.mccLookupShown = action.payload;
    },

    setMccLookupData: (state, action: PayloadAction<Mcc[] | undefined>) => {
        state.mccLookupData = action.payload;
    },
};
